import BaseProxy from './Base';

class KeyProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('keys', parameters);
  }

  update(id, params) {
    return super.update(id, params);
  }
}

export default KeyProxy;
